// Ghost placeholders for empty screenplay blocks.
//
// The legacy renderer painted `data-placeholder` directly onto each
// empty block's DOM node and the CSS at renderer/css/app.css picks
// it up with `[data-placeholder]::before { content: attr(data-placeholder); }`.
// PM owns DOM mutation, so we can't write the attr directly — instead
// we surface it through a NodeDecoration. Decorations live in PM's
// view layer, don't trigger the MutationObserver, and merge their attrs
// with the schema's toDOM output so `class="scene-heading data-block-type=..."`
// keeps working alongside the placeholder.
//
// The plugin guarantees the attr is only set on empty blocks, so the
// matching CSS rule no longer needs the `:empty` selector — PM injects
// a trailing-break `<br>` into empty textblocks for caret visibility,
// which would defeat `:empty` anyway.

import { Plugin } from 'prosemirror-state';
import { Decoration, DecorationSet } from 'prosemirror-view';

// Schema-node-name → hint text.
const PLACEHOLDERS = {
  scene_heading: 'INT./EXT. LOCATION - TIME',
  action: 'Action',
  character: 'CHARACTER NAME',
  parenthetical: '(parenthetical)',
  dialogue: 'Dialogue',
  transition: 'CUT TO:',
  shot: 'SHOT',
};

export function placeholderPlugin() {
  return new Plugin({
    props: {
      decorations(state) {
        const decos = [];
        state.doc.forEach((node, pos) => {
          if (!node.isBlock) return;
          if (node.content.size > 0) return;
          const label = PLACEHOLDERS[node.type.name];
          if (!label) return;
          decos.push(
            Decoration.node(pos, pos + node.nodeSize, {
              'data-placeholder': label,
            }),
          );
        });
        return DecorationSet.create(state.doc, decos);
      },
    },
  });
}
